module.exports = __webpack_public_path__ + "img/创享成都.554952d9.png";